module.exports = __webpack_public_path__ + "static/media/Artboard5.157cbfdf.png";